var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeaceJusticeCooperation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.449 19.0864L16.131 19.6424",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.575 13.2244L11.107 14.3704C10.8387 14.459 10.5471 14.4457 10.2879 14.333C10.0288 14.2203 9.82022 14.0161 9.70201 13.7594C9.57446 13.4857 9.55834 13.1732 9.65706 12.8878C9.75578 12.6025 9.96161 12.3667 10.231 12.2304L13.59 10.5404C13.8763 10.396 14.1892 10.3119 14.5093 10.2934C14.8294 10.2748 15.1499 10.3221 15.451 10.4324L20.424 12.2524",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84399 19.0974L6.28899 19.0974L9.80099 23.0334C9.91623 23.1679 10.057 23.2783 10.2151 23.3581C10.3732 23.4379 10.5456 23.4856 10.7222 23.4984C10.8989 23.5112 11.0763 23.4889 11.2443 23.4328C11.4123 23.3767 11.5675 23.2878 11.701 23.1714L16.136 19.6454C16.3857 19.3956 16.5371 19.0642 16.5622 18.7119C16.5874 18.3597 16.4847 18.0101 16.273 17.7274L13.129 13.7024",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.742 11.9714L10.384 11.6774C10.0964 11.4656 9.75943 11.3306 9.40509 11.2853C9.05074 11.24 8.69069 11.2858 8.359 11.4184L3.909 13.1974",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.908997 11.4974L2.909 11.4974C3.16309 11.4868 3.41103 11.5774 3.59847 11.7493C3.78591 11.9212 3.89757 12.1604 3.909 12.4144L3.909 18.8304C3.89757 19.0845 3.78591 19.3236 3.59847 19.4955C3.41103 19.6674 3.16309 19.758 2.909 19.7474L0.908997 19.7474",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.409 19.7464L21.409 19.7464C21.1549 19.757 20.907 19.6664 20.7195 19.4945C20.5321 19.3226 20.4204 19.0834 20.409 18.8294L20.409 12.4134C20.4204 12.1593 20.5321 11.9201 20.7195 11.7483C20.907 11.5764 21.1549 11.4858 21.409 11.4964L23.409 11.4964",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.843 8.72539C5.63329 7.82852 5.62039 6.89686 5.80517 5.99452C5.98996 5.09219 6.36805 4.2406 6.91343 3.49836C7.45881 2.75612 8.15852 2.14086 8.96442 1.6949C9.77032 1.24894 10.6633 0.982882 11.5818 0.91503C12.5004 0.847178 13.4228 0.979144 14.2854 1.30185C15.1481 1.62455 15.9306 2.13033 16.5792 2.78438C17.2277 3.43843 17.7268 4.22522 18.0422 5.09061C18.3575 5.95599 18.4816 6.87944 18.406 7.79739",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29001 4.54138L7.49801 4.54138C7.96926 4.57669 8.4122 4.77988 8.74635 5.11404C9.08051 5.44819 9.2837 5.89114 9.31901 6.36238L9.31901 8.06238C9.31901 8.31338 9.54301 8.53038 9.79101 8.72738",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.501 1.06439C13.501 1.06439 12.438 1.89739 12.049 2.19739C11.7323 2.43986 11.5242 2.79758 11.4698 3.19272C11.4155 3.58787 11.5195 3.98847 11.759 4.30739L12.674 5.52739C12.8154 5.71429 12.9984 5.86577 13.2083 5.9699C13.4183 6.07402 13.6496 6.12794 13.884 6.12739L14.771 6.12739C14.9697 6.12735 15.1665 6.16646 15.3501 6.24247C15.5337 6.31848 15.7005 6.42991 15.841 6.57039L16.541 7.27039",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.158997 0.197388)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaceJusticeCooperation);
export default __webpack_public_path__ + "static/media/peace_justice_cooperation.43427fc7.svg";
export { ForwardRef as ReactComponent };